export interface IBaseIntegrationType {
	idParts?: string[];
	id?: string;
	integrationOwnerIds?: string[];
}

export interface IBaseIntegrationSource {
	provider?: string;
}

export interface IIntegrationFileSource extends IBaseIntegrationSource {
	integrationFileLocationType?: string;
	integrationFileType?: string;
	path?: string;
}

export interface IIntegrationFailure {
	systemCode?: number;
	systemMessage?: string;
	timestamp?: string; // date
}

export enum IntegrationJobType {
	Unknown = 'Unknown',
	Extract = 'Extract',
	Reload = 'Reload',
	Load = 'Load',
}

export interface IIntegrationJobState extends IBaseIntegrationType {
	currentExtractCount?: number;
	failureCount?: number;
	jobDescription?: string;
	jobEndedAt?: string; // date
	jobId?: string;
	jobStartedAt?: string; // date
	jobType?: IntegrationJobType;
}

export interface IIntegrationJobStateWithLoadCounts extends IIntegrationJobState {
	currentLoadCount?: number;
	totalToLoadCount?: number;
}

export interface IAMS360JobState extends IIntegrationJobState {
	extractContactsBookmark?: string;
	extractContactsNumbericBookmark?: string;
	extractCustomersComplete?: string;
	extractProspectsComplete?: boolean;
}

export interface IFileSourceJobState {
	fileSources?: IIntegrationFileSource[];
}

export type IEclipseJobState = IIntegrationJobState & IFileSourceJobState;

export type IReportCsvJobState = IIntegrationJobState & IFileSourceJobState;

export interface IHubSpotJobState extends IIntegrationJobState {
	extractCompanyBookmark?: string;
	extractCompanySearchBookmark?: string;
	extractContactBookmark?: string;
	extractContactSearchBookmark?: string;
	extractDealBookmakr?: string;
	extractDealSearchBookmark?: string;
	extractEngagementBookmark?: string;
	extractEngagementSearchBookmark?: string;
}

export interface IQQCatalystJobState extends IIntegrationJobState {
	extractContactBookmark?: string;
	extractPolicyBookmark?: string;
}
